// Theme-aware colours for values pages hard-code. Inside an sx prop:
//   sx={{ bgcolor: lightDark("#f5f5f5", DARK.surface), color: lightDark("#344767", DARK.text) }}
// The light value is used verbatim, so light mode looks exactly as it did.
export const lightDark = (light, dark) => (theme) => theme.palette.mode === "dark" ? dark : light;

// Shared dark-mode stand-ins, so every page darkens the same way. They sit on the template's
// dark card (#202940) / page (#1a2035).
export const DARK = {
  text: "#ffffffcc", // body text (the dark theme's text.main); replaces #344767 / #333 / near-black
  textMuted: "rgba(255, 255, 255, 0.6)", // secondary grey text (#666, #888, #7b809a)
  surface: "rgba(255, 255, 255, 0.05)", // pale panel inside a card (#f5f5f5, #fafafa, grey.50/100)
  surfaceHover: "rgba(255, 255, 255, 0.09)", // hover / selected on those panels
  paper: "#202940", // a white box that must stay opaque (the dark card colour)
  border: "rgba(255, 255, 255, 0.12)", // #e0e0e0 / #eee / grey.200 lines and outlines
};

// The built-in logo (/apple-icon.png) is navy on transparent and vanishes on dark surfaces.
// Inverting then turning the hue back keeps it two-tone: light-blue mark, readable lettering.
// Only for that file; an uploaded logo may already be light.
export const DARK_LOGO_FILTER = "invert(1) hue-rotate(180deg)";

// A status colour's pale light-mode background becomes a translucent wash of the same hue.
export const darkTint = (hex, alpha = 0.16) => {
  const n = parseInt(hex.replace("#", ""), 16);
  return `rgba(${(n >> 16) & 255}, ${(n >> 8) & 255}, ${n & 255}, ${alpha})`;
};
